import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PinLock from "@/components/PinLock";
import Layout from "@/components/Layout";
import CreateInvoice from "@/pages/CreateInvoice";
import Orders from "@/pages/Orders";
import Invoices from "@/pages/Invoices";
import Delivery from "@/pages/Delivery";
import Accounts from "@/pages/Accounts";
import Products from "@/pages/Products";
import Settings from "@/pages/Settings";
import Dashboard from "@/pages/Dashboard";
import Expenses from "@/pages/Expenses";
import EmailTemplates from "@/pages/EmailTemplates";
import PublicSign from "@/pages/PublicSign";

import AccountForm from "@/pages/AccountForm";

const STORAGE_KEY = "jl_unlocked";

function AppInner({ unlocked, onUnlock, onLock }) {
  const location = useLocation();

  // Public sign page — bypasses PIN lock entirely
  if (location.pathname.startsWith("/sign/")) {
    return <PublicSign />;
  }

  // Public account application form — bypasses PIN lock entirely
  if (location.pathname.startsWith("/account-form/")) {
    return <AccountForm />;
  }

  if (!unlocked) {
    return <PinLock onUnlock={onUnlock} />;
  }

  return (
    <Layout onLock={onLock}>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/create" element={<CreateInvoice />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/delivery" element={<Delivery />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/products" element={<Products />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/email-templates" element={<EmailTemplates />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  const [unlocked, setUnlocked] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY) === "1") setUnlocked(true);
  }, []);

  const unlock = () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setUnlocked(true);
  };
  const lock = () => {
    sessionStorage.removeItem(STORAGE_KEY);
    setUnlocked(false);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <AppInner unlocked={unlocked} onUnlock={unlock} onLock={lock} />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
